export const rolesMap = {
    beta: `service:beta`,
    rmaOverride: `service:admin:rma:override:oow`,
    createPartOrder: 'service:partorder:create',
    paymentPO: 'service:payment:po',
    multipleRMA: 'service:rma:multiple',
    videoSerialPermission: 'service:video:serial:read'
}
